<template>
  <div>
    <div>
      <div class="text-container">
        <p class="text-justify ">
          Navigate through Proxima by using the menu on the left-hand side.
        </p>
        <p class="text-justify">
          Click on
          <strong><a class="user-guide-link" href="/#/app/files">"Market Analysis"</a></strong>
          to see market overview and market outlook analysis, as well as interactive data files.
        </p>
        <p class="text-justify">
          Click on
          <strong><a class="user-guide-link" href="/#/app/proxima">"Asset Profiles"</a></strong>
          to use our interactive mapping tool.
        </p>
        <p class="text-justify">
          Click on
          <strong><a class="user-guide-link" href="/#/cost-analysis">"Cost Analysis"</a></strong>
          to see cost model services and cost trackers.
        </p>
        <p class="text-justify">Click on
          <strong><a class="user-guide-link" href="/#/market-data">"Data Dashboards"</a></strong> to conduct analysis using our supply, demand, price, trade and country data.
        </p>
        <p class="text-justify">
          Click on
          <strong><a class="user-guide-link" href="/#/monthlies">"Supply Chain Monthlies"</a></strong>
          to access analysis and forecasts on key end-use markets.
        </p>
        <p class="text-justify">
          For
          <strong><a class="user-guide-link" href="/#/support">"Analyst Access"</a></strong>
          please send us a message via the dedicated chat function.
        </p>
        <p class="text-justify">Best wishes, The Project Blue team</p>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>